<template>
    <section>
        <div class="func-item-toggle" @click="toggleDisplay">
            <span class="ui-btn-right">
                <span class="text">{{ _ll('运费查询其他说明') }}</span>
                <span class="ui-ico" :class="{ 'ui-ico-up': showContent, 'ui-ico-down': !showContent }"></span>
            </span>
        </div>
        <div v-show="showContent" class="func-item-con ui-article">
            <div id="content_detail">
                <div class="content-page news-content-wrapper">
                    <div class="news-detail">
                        <h1 class="news-title"></h1>
                        <div class="news-content">
                            <p><strong>运费计算基于以下计费重量规则：</strong></p>
                            <p><strong>1. &nbsp;</strong><strong>体积重量判断规则</strong></p>
                            <p>托寄物的计费重量取体积重量与实际重量两者之间的较大值，体积重量的计算方法为：</p>
                            <p>[<strong>顺丰即日/顺丰特快</strong>]</p>
                            <p>同城、省内件以及经济区域内互寄，体积重量=长(CM)×宽(CM)×高(CM)÷12000；</p>
                            <p>省外跨经济区域互寄，体积重量=长(CM)×宽(CM)×高(CM)÷6000；</p>
                            <p>(经济区域包含：京津冀区域，江浙沪皖区域,，川渝区域，黑吉辽区域)</p>
                            <p>[<strong>顺丰标快</strong>] 体积重量=长(CM)×宽(CM)×高(CM)÷12000；</p>
                            <p>[<strong>重货包裹/小票零担/冷运到家</strong>] 体积重量=长(CM)×宽(CM)×高(CM)÷6000；</p>
                            <p>[<strong>冷运零担</strong>] 体积重量=长(CM)×宽(CM)×高(CM)÷3000；</p>
                            <p>[<strong>港澳台/国际件业务</strong>] 体积重量=长(CM)×宽(CM)×高(CM)÷6000</p>
                            <p>其他产品规则请致电95338或咨询当地收派员。</p>
                            <p><strong>2. 计费重量小数点进位规则</strong></p>
                            <p>[<strong>中国大陆互寄</strong>]</p>
                            <p>100KG以下, 续重以0.5KG为计重单位, 不足0.5kg，按0.5kg计。100KG及以上, 四舍五入取整数。</p>
                            <p>[<strong>港澳本地</strong>]</p>
                            <p>续重以0.5KG为计重单位, 不足0.5kg，按0.5kg计。</p>
                            <p>[<strong>进出口业务</strong>]</p>
                            <p>
                                20KG以下, 续重以0.5KG为计重单位, 不足0.5kg，按0.5kg计；20KG及以上, 以1KG为计重单位, 小数点后尾数大于零的,
                                向上进位至下一个1KG。
                            </p>
                            <p>计费重量规则可能因服务(产品)或所在地区不同而有所差异，详情致电95338或与当地收派员进行咨询。</p>
                            <p>&nbsp;</p>
                            <p><strong>温馨提示：</strong></p>
                            <p><strong>始发地或目的地任一方为港澳台地区</strong><strong>：</strong></p>
                            <p style="padding-left: 30px">
                                1、此价格供参考。更多收费和服务详情，详情请致电大陆客户服务热线&nbsp;<strong>95338</strong>。
                            </p>
                            <p style="padding-left: 30px">
                                2、港澳寄往中国大陆的特殊包裹品项及价格请<a
                                    href="http://owf-manage.sf-express.com/opencms/export/ESG_OWF_CORE/export/sf/cn/sc/download/Special_Express_Service_HongkongMacau_to_Mainland_China.pdf"
                                    >按此</a
                                >查询。
                            </p>
                            <p style="padding-left: 30px">
                                3、台湾寄往中国大陆的特殊包裹品项及价格请<a
                                    href="http://owf-manage.sf-express.com/opencms/export/ESG_OWF_CORE/export/sf/cn/sc/download/-.pdf"
                                    >按此</a
                                >查询。
                            </p>
                            <p style="padding-left: 30px">
                                4、对于约定由收件人（或第三方）付费（含运费及增值服务费）的快件，在快件签收之前，可提出对费用付款方式变更为寄方付。对于需要更改付款方式的快件，寄件人除需要支付运费外，每票需另外支付更改付款方式服务费。（<a
                                    href="http://owf-manage.sf-express.com/opencms/export/ESG_OWF_CORE/export/sf/mobile/cn/sc/express/express_service/added_service/change_payment_method/"
                                    >收费标准</a
                                >）
                            </p>
                            <p style="padding-left: 30px">
                                5、如收派件地址为<span style="text-decoration: underline">香港住宅地址</span>或<a
                                    href="http://owf-manage.sf-express.com/opencms/export/ESG_OWF_CORE/export/sf/cn/sc/download/Remote_area_SC001.pdf"
                                    >香港偏远地区</a
                                >，
                            </p>
                            <p>
                                上门收派每票另收港币（住宅附加费$20，香港偏远件$30），附加费可与运费绑定（寄付或到付），收派件时效需加0.5-1个工作日。
                            </p>
                            <p style="padding-left: 30px">
                                6、台湾部分地区收派时效需加0.5-1工作日，可<a
                                    href="http://owf-manage.sf-express.com/opencms/export/ESG_OWF_CORE/export/sf/cn/sc/download/TW_Remote_area_TC01.PDF"
                                    >按此</a
                                >查阅详情。
                            </p>
                            <p style="padding-left: 30px">
                                7、以上由香港、澳门及台湾寄件至中港澳台之运费包含燃油附加费，请<a
                                    title="燃油附加费新标准（官网内容更新 大陆版）最新（中文版）-201707--1"
                                    href="http://www.sf-express.com/cn/sc/download/CN-1810-Fuel-Surcharge.pdf"
                                    >按此</a
                                >了解更多燃油附加费的资料。
                            </p>
                            <p style="padding-left: 30px">&nbsp;</p>
                            <p><strong>始发地或目的地任一方为海外国家</strong><strong>:</strong></p>
                            <p style="padding-left: 30px">
                                1、海外进出口流向价格与时效仅参考。更多收费与服务详情，请致电大陆国际业务客服专线9533883.
                            </p>
                            <p style="padding-left: 30px">
                                2、海外进出口流向运费豁免燃油附加费，但未包含清关税费、偏远地区附加费、特殊处理费等可能产生的其他费用。
                            </p>
                            <p style="padding-left: 30px">
                                3、海外进出口流向时效标准天数是指工作日，不包含收件日，不包括周末和节假日。具体派送时效以目的地邮编为准。如遇偏远地区或郊区、航班延误、清关异常等情形，时效会额外增加。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PayFeeContentDetail',
    data() {
        return {
            showContent: false
        }
    },
    methods: {
        toggleDisplay() {
            if (this.showContent) {
                this.showContent = false
            } else {
                this.showContent = true
            }
        }
    }
}
</script>

<style scoped>
.func-item-toggle {
    padding: 10px 5px 10px 10px;
    border-top: #ddd 1px solid;
    border-bottom: #ddd 1px solid;
    display: block;
    background-color: #fff;
}
.func-item-toggle .text {
    display: block;
    padding: 5px 0;
    color: #333;
}
.ui-ico {
    height: 22px;
    width: 22px;
    background-size: 383px auto;
    margin-bottom: 0.3em;
    background-image: url(../../assets/images/sixpart/ico_css_main.png);
}
.ui-ico-down {
    background: url(../../assets/images/sixpart/ico_arrow_down.png) no-repeat right 50%;
    background-size: auto 10px;
}
.ui-ico-up {
    background: url(../../assets/images/sixpart/ico_arrow_up.png) no-repeat right 50%;
    background-size: auto 10px;
}
.func-item-con {
    border-bottom: #ddd 1px solid;
    padding: 10px;
    background-color: #fff;
}
.ui-article {
    margin: 0 0 9px;
}
.ui-article p {
    margin: 0 0 9px;
}
.news-detail .news-content {
    padding: 13px 22px;
}
.ui-article a {
    color: #ec2200;
    text-decoration: underline;
}
.ui-btn-right {
    padding-right: 30px;
    position: relative;
    z-index: 0;
    display: block;
}
a {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-content-detail.vue